import templateUrl from "emun.on-demand/design-ratio-picker.htm";
import DesignRatioPickerController from "emun.on-demand/design-ratio-picker.controller";
import open from "webmodals/open";

let designRatioPicker = options => {
  let modalInstance = open({
    size: options.size || "md",
    backdrop: options.backdrop || "dynamic",
    templateUrl: options.templateUrl || templateUrl,
    controller: DesignRatioPickerController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default designRatioPicker;
